/**
 * VCIN Brand Colors - Single source of truth
 * 
 * ⚠️  CRITICAL: Import this file anywhere colors are needed
 * ⚠️  NEVER use Tailwind blue classes (bg-blue-*, text-blue-*)
 * ⚠️  NEVER use hex values like #1565C0, #1d4ed8, #2563eb, #3b82f6, #E3F2FD
 * ⚠️  Always use: style={{ backgroundColor: VCIN_COLORS.primary }}
 * ⚠️  Always use: style={{ color: VCIN_COLORS.primary }}
 * 
 * The police blue #003087 is the ONLY blue color allowed in this application.
 */

export const VCIN_COLORS = {
  // Primary brand colors - POLICE BLUE #003087
  primary: '#003087',        // Police blue - main buttons, headers, icons
  primaryHover: '#002266',   // Darker blue for hover states
  gold: '#FFD700',           // Gold accent - active states, highlights
  
  // Alert colors
  alertRed: '#C8102E',       // BANNED, critical alerts
  alertAmber: '#E07B00',     // Warning, elevated threat
  alertGreen: '#006B3C',     // Success, no threat
  
  // Threat level colors
  threatLevel0: '#E8F5E9',   // No threat - light green
  threatLevel1: '#FFF8E1',   // Low - light amber
  threatLevel2: '#FFF3E0',   // Moderate - light orange
  threatLevel3: '#FFEBEE',   // Elevated - light red
  threatLevel4: '#FFCDD2',   // High - medium red
  threatLevel5: '#B71C1C',   // Critical - dark red
  
  // UI colors
  background: '#E8EAF0',     // App background
  surface: '#FFFFFF',        // Cards, modals
  text: '#0A1628',           // Primary text
  textSecondary: '#4A5568',  // Secondary text
  border: '#D8DCE4',         // Borders
  
  // UK Plate colors
  plateYellow: '#FFC425',    // UK plate background
  plateBlack: '#000000',     // UK plate text/border
};

export default VCIN_COLORS;
